import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let DiyMixin = class DiyMixin extends Vue {
    successFormSubmission() {
        this.$emit('submit:success');
    }
    onNext() {
        this.$emit('diy:next');
    }
    onPrevious() {
        this.$emit('diy:previous');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], DiyMixin.prototype, "diy", void 0);
DiyMixin = __decorate([
    Component
], DiyMixin);
export default DiyMixin;
